const GA_MEASUREMENT_ID = 'G-49ZF954EMS';
const GOOGLE_TAG_ID = 'GT-PJRMWT8T';

function initializeAnalytics() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  if (!document.querySelector(`script[data-google-tag="${GOOGLE_TAG_ID}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`;
    script.dataset.googleTag = GOOGLE_TAG_ID;
    document.head.appendChild(script);
  }
  if (!window.__gemGaConfigured) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
    window.__gemGaConfigured = true;
  }
}

export function trackPageView(path) {
  initializeAnalytics();
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
  });
}
